module.exports = __webpack_public_path__ + "static/media/62.fe48a5aa.svg";